const siteInfo = {
    siteName: "Optmize your trade"
};

export const APP_VERSION = "1.7.11";
export const LAST_UPDATE_DATE = "09/19/2025 - 09:30:00";
